/* eslint-disable @typescript-eslint/camelcase */
import { TOffice } from '@/apps/appCreator/components/CarOfficeCard';
import { createSelector } from '@reduxjs/toolkit';
import { Car } from '@lib/azgaz-ui/connect';
import _ from 'lodash';

const getCarDealerOffices = createSelector(
  (car: Car) => car,
  ({ dealer, dealerName, office_ids }) => {
    if (!dealer) {
      return {};
    }

    const resolvedOffices: TOffice[] = dealer.offices
      ?.filter((dealerOffice: TOffice) => {
        if (!office_ids || office_ids?.length === 0) {
          return true;
        }
        return office_ids.includes(dealerOffice.id);
      })
      .map((office: TOffice) => {
        const proccesedOffice = _.cloneDeep(office);
        const { location } = proccesedOffice;

        if (!location) {
          return proccesedOffice;
        }
        // переворачиваем координаты чтоб широта была первой в массиве(формат яндекс карт)
        proccesedOffice.location.coordinates = location.coordinates
          .slice()
          .reverse() as [number, number];

        return proccesedOffice;
      });

    return {
      offices: resolvedOffices,
      officesTitle:
        resolvedOffices.length === 1
          ? `${resolvedOffices[0].name}, ${resolvedOffices[0].city}`
          : dealerName,
    };
  }
);

export default getCarDealerOffices;
